(() => {
  'use strict';
  if (window.__ibPrepublishV55Loaded) return;
  window.__ibPrepublishV55Loaded = true;

  const clean = (value) => String(value || '').replace(/\s+/g, ' ').trim();
  const language = () => (document.documentElement.lang || 'es').toLowerCase().split('-')[0];
  const storefrontRoot = () => {
    const root = String(window.Shopify?.routes?.root || '/');
    return root.endsWith('/') ? root : `${root}/`;
  };
  const copy = {
    es: ['No se han encontrado productos para tu búsqueda.', 'Prueba con otro término, consulta todo el catálogo o contacta con nuestro equipo técnico.', 'Ver todos los productos'],
    en: ['No products were found for your search.', 'Try another term, browse the full catalogue or contact our technical team.', 'View all products'],
    fr: ['Aucun produit ne correspond à votre recherche.', 'Essayez un autre terme, consultez tout le catalogue ou contactez notre équipe technique.', 'Voir tous les produits'],
    de: ['Für Ihre Suche wurden keine Produkte gefunden.', 'Versuchen Sie einen anderen Suchbegriff, öffnen Sie den gesamten Katalog oder kontaktieren Sie unser Technikteam.', 'Alle Produkte ansehen'],
    it: ['Nessun prodotto trovato per la ricerca.', 'Prova un altro termine, consulta l’intero catalogo o contatta il nostro team tecnico.', 'Vedi tutti i prodotti'],
    nl: ['Er zijn geen producten voor je zoekopdracht gevonden.', 'Probeer een andere zoekterm, bekijk de volledige catalogus of neem contact op met ons technische team.', 'Bekijk alle producten'],
    pt: ['Não foram encontrados produtos para a sua pesquisa.', 'Experimente outro termo, consulte todo o catálogo ou contacte a nossa equipa técnica.', 'Ver todos os produtos'],
  };

  const annotateVariants = (root = document) => {
    root.querySelectorAll('variant-picker .variant-option__button-label, variant-picker .variant-option__select')
      .forEach((element) => element.setAttribute('data-variant-option', 'true'));
  };

  let activeQuickAdd = null;
  let skuFrame = 0;

  const selectedVariant = (root) => {
    for (const script of root.querySelectorAll('variant-picker script[type="application/json"]')) {
      try {
        const value = JSON.parse(script.textContent || 'null');
        if (value && (value.id || value.sku)) return value;
      } catch {}
    }
    return null;
  };

  const syncQuickAddSku = () => {
    skuFrame = 0;
    const root = document.getElementById('quick-add-modal-content');
    if (!root) return;
    annotateVariants(root);

    const sku = clean(selectedVariant(root)?.sku || activeQuickAdd?.dataset.productSku);
    if (!sku || sku === '__ib_no_sku__') return;

    let node = root.querySelector('[data-ib-quick-add-sku]');
    if (!node) {
      node = document.createElement('p');
      node.className = 'ib-quick-add-sku';
      node.dataset.ibQuickAddSku = '';
      node.dataset.testid = 'product-sku';
      node.setAttribute('itemprop', 'sku');
      const anchor = root.querySelector('.product-header, .view-product-title, .product-details') || root.firstElementChild;
      anchor?.parentElement ? anchor.insertAdjacentElement('afterend', node) : root.prepend(node);
    }
    node.hidden = false;
    node.removeAttribute('aria-hidden');
    node.textContent = `SKU: ${sku}`;
  };

  const scheduleSku = () => {
    if (!skuFrame) skuFrame = requestAnimationFrame(syncQuickAddSku);
  };

  const searchEmpty = () => {
    const url = new URL(location.href);
    const root = storefrontRoot();
    const rootPath = new URL(root, location.origin).pathname.replace(/\/$/, '');
    const currentPath = url.pathname.replace(/\/$/, '') || '/';
    const relativePath = rootPath && currentPath.startsWith(rootPath)
      ? (currentPath.slice(rootPath.length) || '/')
      : currentPath;
    if (relativePath !== '/search' || !clean(url.searchParams.get('q'))) return;

    const resultsRoot = document.querySelector('results-list');
    if (!resultsRoot) return;
    const existing = resultsRoot.querySelector('[data-ib-search-empty]');
    const hasProducts = Boolean(resultsRoot.querySelector('product-card, .product-card, [data-product-id]'));
    if (hasProducts) return existing?.remove();
    if (existing) return;

    const [title, text, linkText] = copy[language()] || copy.es;
    const section = document.createElement('section');
    section.className = 'ib-search-empty';
    section.dataset.ibSearchEmpty = '';
    section.setAttribute('role', 'status');

    const heading = document.createElement('h2');
    heading.textContent = title;
    const paragraph = document.createElement('p');
    paragraph.textContent = text;
    const link = document.createElement('a');
    link.className = 'button button--primary';
    link.href = `${root}collections/all`;
    link.textContent = linkText;
    section.append(heading, paragraph, link);

    (resultsRoot.querySelector('.collection-wrapper') || resultsRoot).prepend(section);
  };

  const portuguese404 = () => {
    if (language() !== 'pt') return;
    const main = document.querySelector('main');
    if (!main) return;
    const heading = main.querySelector('h1');
    const message = [...main.querySelectorAll('p')].find((p) => /la página que estás buscando no existe/i.test(clean(p.textContent)));
    const link = [...main.querySelectorAll('a')].find((a) => /volver a la tienda/i.test(clean(a.textContent)));
    if (heading && /página no encontrada/i.test(clean(heading.textContent))) heading.textContent = 'Página não encontrada';
    if (message) message.textContent = 'Lamentamos, mas a página que procura não existe. A ligação pode estar incorreta ou a página pode ter sido removida.';
    if (link) link.textContent = 'Voltar à loja';
  };

  const apply = () => {
    annotateVariants();
    searchEmpty();
    portuguese404();
    scheduleSku();
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('.quick-add__button--choose');
    if (!button) return;
    activeQuickAdd = button.closest('quick-add-component');
    scheduleSku();
  }, true);

  document.addEventListener('change', (event) => {
    if (event.target.closest?.('#quick-add-modal-content')) scheduleSku();
  });

  const start = () => {
    apply();
    const quickAdd = document.getElementById('quick-add-dialog');
    if (quickAdd) {
      new MutationObserver(() => {
        annotateVariants(quickAdd);
        scheduleSku();
      }).observe(quickAdd, { childList: true, subtree: true, characterData: true });
    }
    document.addEventListener('shopify:section:load', apply);
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', start, { once: true })
    : start();
})();
